<template>
  <component
    :is="configurationTab"
    :sensor="sensor"
    :category="category"
    :selected-information="selectedInformation"
    :sensor-information="sensorInformation"
    :is-sensor-componentized="isSensorComponentized"
    @on-change-selected-information="onChangeSelectedInformationHandler"
  />
</template>

<script>
import { configurationTabs } from '@/domain/data/installation/supervision/sensors/featureTabs';

export default {
  props: {
    sensor: Object,
    category: String,
    isSensorComponentized: {
      type: Boolean,
      default: true,
    },
    selectedInformation: {
      type: Object,
      default: () => ({}),
    },
    sensorInformation: {
      type: Array,
      default: () => ([]),
    },
  },
  computed: {
    configurationTab() {
      const component = configurationTabs[this.sensor.subtype];
      if (!component) {
        throw new Error(`Not supported configuration tab for E3LibType "${this.sensor.subtype}"`);
      }

      return component;
    },
  },
  methods: {
    onChangeSelectedInformationHandler(value) {
      this.$emit('on-change-selected-information', value);
    },
  },
};
</script>
